module.exports = __webpack_public_path__ + "img/2016.070a31ef.png";